import * as React from 'react';

function SvgInformationCircleOutline(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { stroke: "currentColor", strokeMiterlimit: 10, strokeWidth: 1.6, d: "M12 2C6.478 2 2 6.478 2 12s4.478 10 10 10 10-4.478 10-10S17.522 2 12 2z" }),
        React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.6, d: "M10.479 10.48h1.74v6.304" }),
        React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeMiterlimit: 10, strokeWidth: 1.6, d: "M9.827 17.002h4.782" }),
        React.createElement("path", { fill: "currentColor", d: "M12 5.588a1.413 1.413 0 100 2.826 1.413 1.413 0 000-2.826z" })));
}

export default SvgInformationCircleOutline;
